import Nullstack from 'nullstack';
export default function IconBrightnessUp({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brightness-up",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "3"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "7",
    x2: "18.4",
    y2: "5.6"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "12",
    x2: "21",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "17",
    x2: "18.4",
    y2: "18.4"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "17",
    x2: "5.6",
    y2: "18.4"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "12",
    x2: "4",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "7",
    x2: "5.6",
    y2: "5.6"
  }), " ");
}